import { c as _c } from "react/compiler-runtime";
import { usePasswordInput } from "../../inputs";
import type { PasswordFormGroupDependencies, PasswordFormGroupProps } from "./PasswordFormGroup.d";

/**
 * @function usePasswordFormGroups
 * @param {PasswordInputDependencies} deps
 * @returns {PasswordFormGroupProps}
 */
export const usePasswordFormGroup = t0 => {
  const $ = _c(9);
  let deps;
  let label;
  if ($[0] !== t0) {
    ({
      label,
      ...deps
    } = t0);
    $[0] = t0;
    $[1] = deps;
    $[2] = label;
  } else {
    deps = $[1];
    label = $[2];
  }
  let t1;
  if ($[3] !== deps || $[4] !== label) {
    t1 = {
      ...deps,
      label
    };
    $[3] = deps;
    $[4] = label;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const props = usePasswordInput(t1);
  let t2;
  if ($[6] !== label || $[7] !== props) {
    t2 = {
      ...props,
      label
    };
    $[6] = label;
    $[7] = props;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};